import { useEffect, useState } from 'react';

export type WakeState = 'pending' | 'on' | 'unsupported';

/**
 * Bildschirm anlassen, solange die Komponente steht (Kochen, Familienanzeige). iOS gibt die Sperre beim
 * Wechsel in den Hintergrund frei — beim Zurückkommen wird sie neu angefordert.
 */
export function useWakeLock(): WakeState {
  const [state, setState] = useState<WakeState>('pending');

  useEffect(() => {
    const api = (navigator as Navigator & { wakeLock?: WakeLock }).wakeLock;
    if (!api) {
      setState('unsupported');
      return;
    }
    let sentinel: WakeLockSentinel | null = null;
    let active = true;

    const request = async () => {
      try {
        sentinel = await api.request('screen');
        if (!active) {
          void sentinel.release();
          return;
        }
        setState('on');
      } catch {
        setState('unsupported');
      }
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') void request();
    };

    void request();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      document.removeEventListener('visibilitychange', onVisible);
      void sentinel?.release();
    };
  }, []);

  return state;
}
